import React, { useEffect, useRef } from "react";

/**
 * GMO I/F呼出画面
 * @returns
 */
const NavigatePay = () => {
  const firstRenderRef = useRef(true);

  const postPayment = (url, accessId, token) => {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = url;

    const inputAccessId = document.createElement("input");
    inputAccessId.type = "hidden";
    inputAccessId.name = "AccessID";
    inputAccessId.value = accessId;
    const inputToken = document.createElement("input");
    inputToken.type = "hidden";
    inputToken.name = "Token";
    inputToken.value = token;
    form.appendChild(inputAccessId);
    form.appendChild(inputToken);

    form.style.display = "none";
    document.body.appendChild(form);
    form.submit();
  };

  useEffect(() => {
    if (process.env.NODE_ENV === "development" && firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }
    const params = new URLSearchParams(window.location.search);
    postPayment(
      params.get("startUrl"),
      params.get("accessId"),
      params.get("token")
    );
  }, []);

  return <></>;
};

export default NavigatePay;
